/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type GetHardwareItemsQueryVariables = Types.Exact<{
  where: Types.HardwareItemWhereInput;
  event_slug?: Types.Maybe<Types.Scalars["String"]>;
}>;

export type GetHardwareItemsQuery = {
  hardwareItems: Array<
    Pick<
      Types.HardwareItem,
      | "id"
      | "sku_code"
      | "created_at"
      | "updated_at"
      | "total_quantity"
      | "available_quantity"
    >
  >;
};

export const GetHardwareItemsDocument = gql`
  query GetHardwareItems($where: HardwareItemWhereInput!, $event_slug: String) {
    hardwareItems(where: $where, event_slug: $event_slug) {
      id
      sku_code
      created_at
      updated_at
      total_quantity
      available_quantity
    }
  }
`;

/**
 * __useGetHardwareItemsQuery__
 *
 * To run a query within a React component, call `useGetHardwareItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHardwareItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHardwareItemsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      event_slug: // value for 'event_slug'
 *   },
 * });
 */
export function useGetHardwareItemsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetHardwareItemsQuery,
    GetHardwareItemsQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetHardwareItemsQuery,
    GetHardwareItemsQueryVariables
  >(GetHardwareItemsDocument, baseOptions);
}
export function useGetHardwareItemsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetHardwareItemsQuery,
    GetHardwareItemsQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetHardwareItemsQuery,
    GetHardwareItemsQueryVariables
  >(GetHardwareItemsDocument, baseOptions);
}
export type GetHardwareItemsQueryHookResult = ReturnType<
  typeof useGetHardwareItemsQuery
>;
export type GetHardwareItemsLazyQueryHookResult = ReturnType<
  typeof useGetHardwareItemsLazyQuery
>;
export type GetHardwareItemsQueryResult = ApolloReactCommon.QueryResult<
  GetHardwareItemsQuery,
  GetHardwareItemsQueryVariables
>;
